import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MDButton from "components/MDButton";
import { Box, TextField } from "@mui/material";
import { toast } from "sonner";

import { PersonAdd } from "@mui/icons-material";

import { useAddAcademicYear } from "hooks/settingsHooks/useAddAcademicYear";
// { open, handleClose }

const AddAcademicYearPopup = () => {
  const [open, setOpen] = useState(false);
  const [academicyear, setAcademicYear] = useState("");
  const { addacademicyear, error, isLoading, success, setError, setSuccess } =
    useAddAcademicYear();

  useEffect(() => {
    if (error) {
      toast.error("Failed to add academic year");
    }
    if (success) {
      toast.success("Academic year added successfully");
      handleClose();
    }
  }, [error, success]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(academicyear);
    await addacademicyear(academicyear);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    //clear all fields
    setAcademicYear("");
    // Clear error on close
    setError(null);
    setSuccess(null);
  };

  return (
    <div>
      <MDButton
        variant="contained"
        color="info"
        size="small"
        startIcon={<PersonAdd />}
        onClick={handleClickOpen}
      >
        Add Academic Year
      </MDButton>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: { padding: 20, borderRadius: 10 },
        }}
      >
        <DialogTitle>Add Academic Year</DialogTitle>
        <DialogContent>
          <Box display="flex" justifyContent="center" alignItems="center">
            <TextField
              label="Enter Academic year..."
              name="academicYear"
              value={academicyear}
              onChange={(e) => setAcademicYear(e.target.value)}
              fullWidth
              variant="outlined"
              margin="normal"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleClose}>Cancel</MDButton>
          <MDButton
            onClick={handleSubmit}
            variant="contained"
            color="info"
            disabled={isLoading}
          >
            Submit
          </MDButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddAcademicYearPopup;
